// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ns-progress[data-v-810b4508]{width:100%;height:6px;border-radius:3px;background:#eee;overflow:hidden}.ns-progress-bar[data-v-810b4508]{border-radius:3px;height:6px;transition:all .1s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
